import feedback from "../common-components/feedback/feedback";

export const pageBlockId = {
    // student
    studentApps: 1,
    studentResources: 2,
    planNextTerm: 3,
    quickLinks: 5,
    help: 6,
    accountResources: 8,
    scholarship: 9,
    degreeProgress: 10,
    earlyAlerts: 11,
    studentNotification: 12,
    studentCareerPath: 34,
    financialAssistance: 35,

    // staff
    hrAndBenefits: 13,
    financeResources: 14,
    campusEvents: 15 ,
    campusSafety: 16,
    technologyResources: 17,
    staffNotification: 24,
    reportResources: 25,
    trainingHelp: 26,
    departmentResources: 27,
    trainingBlocks: 29,

    // faculty
    facultyResources: 19,
    facultyApps: 20,
    facultyQuickLinks: 21,
    facultyNotification: 22,
    facultyReports: 23,

    //common
    feedback: 31,
    staffFeedback: 30,
    facultyFeedback: 32
};


export const limit = {
    one: 1,
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
    seven: 7,
    eight: 8,
    nine: 9,
    ten: 10,
    eleven: 11,
    twelve: 12,
}

export const emailBlockId = {
    Feedback: 1,
    Financial_Assistance: 2,
    Campus_Safety: 3,
    Contact_Student_Success: 4
}

export const helpContact = {
    department: 1,
    faculty: 2,
    advisor: 3,
    contactSuccessStudent: 4
}